/**
 * Copyright Higharc Inc. 2019
 */
import type * as THREE from "three";
import { normalPackingHelpersGLSL } from "./normalPackingHelpersGLSL";
import { UVVertexShader } from "./UVVertexShader";

interface DisplayNormalShaderType {
  defines: {
    NORMAL_PACKING: number; // eslint-disable-line @typescript-eslint/naming-convention
  };
  uniforms: {
    tNormal: THREE.IUniform;
  };
  vertexShader: string;
  fragmentShader: string;
}

export const DisplayNormalShader: DisplayNormalShaderType = {
  defines: {
    NORMAL_PACKING: 1,
  },

  uniforms: {
    tNormal: { value: null },
  },

  vertexShader: UVVertexShader,

  fragmentShader: `#include <packing>

${normalPackingHelpersGLSL}

uniform sampler2D tNormal;

varying vec2 vUv;

vec3 getViewNormal( const in vec2 screenPosition ) {
  #if NORMAL_PACKING == 1
  return unpackRGBAToNormal( texture2D( tNormal, screenPosition ) );
  #else
  return unpackRGBToNormal( texture2D( tNormal, screenPosition ).xyz );
  #endif
}

void main() {
  gl_FragColor = vec4( packNormalToRGB( getViewNormal( vUv ) ), 1.0 );
}`,
};
